import { Link, Outlet, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  CHANGE_PASSWORD_URL_LOCAL,
  HOME_URL_LOCAL,
  ORDERS_URL_LOCAL,
  PROFILE_URL_LOCAL,
  SECTION_USER_URL_LOCAL,
  SHOPPINGCART_URL_LOCAL,
} from "../../utility/BaseUrl";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { clearCookie } from "../../utility/Cookies";
import { handleLogout } from "../../utility/PublicComponent";

export default function BaseProfileScreen({ user }) {
  const { name, family, image } = user;
  let navigate = useNavigate();

  useEffect(() => {
    const link1 = document.createElement("link");
    link1.rel = "stylesheet";
    link1.type = "text/css";
    link1.href = "/user/panel.css";

    const link2 = document.createElement("link");
    link2.rel = "stylesheet";
    link2.href = "/user/panel-override.css";

    document.head.appendChild(link1);
    document.head.appendChild(link2);

    return () => {
      document.head.removeChild(link1);
      document.head.removeChild(link2);
    };
  }, []);

  if (!user) return;

  const fullName = name + " " + family;
  return (
    <>
      <div>
        <div className="topbar-wrapper">
          <ul className="topbar-links">
            <li className="dropdown">
              <a
                role="button"
                className="topbar-profile tempDisabled"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-user" />
                <span className="hidden-md-down">
                  {fullName}
                  <i className="fa fa-caret-down" />
                </span>
              </a>
              <ul className="dropdown-menu dropdown-menu-left topbar-list topbar-list--sm">
                <li>
                  <img
                    className="center-block margin-top-sm margin-bottom-sm"
                    src={BASE_URL + image}
                    alt={fullName}
                    title={fullName}
                  />
                </li>
                <li>
                  <Link to={PROFILE_URL_LOCAL}>
                    <i className="fa fa-user pull-left" />
                    پروفایل
                  </Link>
                </li>
                <li>
                  <Link to={CHANGE_PASSWORD_URL_LOCAL}>
                    <i className="fa fa-lock pull-left" />
                    تغییر رمز عبور
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={() => handleLogout(navigate)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-power-off pull-left" />
                    خروج
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li className="hidden-xs">
          <a
            href="/user/billing/balance"
            data-toggle="tooltip"
            data-placement="bottom"
            title
            data-original-title="موجودی کیف‌پول"
          >
            <i className="fa fa-fw fa-money" />0 تومان
          </a>
        </li>  <li className="dropdown visible-xs">
          <a
            role="button"
            data-toggle="dropdown"
            style={{ width: 40, padding: "7px !important" }}
            className="tempDisabled"
          >
            <i className="fa fa-fw fa-money" />
          </a>
          <ul className="dropdown-menu dropdown-menu-left topbar-list topbar-list--sm">
            <li style={{ padding: "0 10px" }}>
              <small>موجودی کیف‌پول:</small> 0 <small>تومان</small>
            </li>
          </ul>
        </li> */}
          </ul>
          <a
            role="button"
            className="topbar-menu-bars tempDisabled"
            data-toggle="collapse"
            data-target="#menu-wrapper"
            aria-expanded="true"
          >
            <i class="fa fa-bars"></i>
          </a>
        </div>
        <div className="body-wrapper">
          <div
            className="menu-wrapper collapse"
            id="menu-wrapper"
            aria-expanded="true"
          >
            <ul>
              <li>
                <Link to={SECTION_USER_URL_LOCAL} data-link-direct>
                  <i className="fa fa-home" />
                  میزکار
                </Link>
              </li>
              <li>
                <Link to={ORDERS_URL_LOCAL} data-link-direct>
                  <i className="fa fa-shopping-cart" />
                  سفارش‌ها
                </Link>
              </li>
              <li className="d-md-none text-center d-flex justify-content-center">
                <a
                  role="button"
                  data-toggle="collapse"
                  data-target="#menu-wrapper"
                  aria-expanded="true"
                  data-link-direct="true"
                  className=" topbar-menu-bars tempDisabled"
                >
                  بستن
                </a>
              </li>
            </ul>
          </div>
        
          <Outlet />
          <div className="clearfix" />
        </div>
      </div>
    </>
  );
}
